import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { GetPeopleLedgerDetailResponse, LargeCategoryCode, PeopleLedgerSection } from './type';
export async function getPeopleLedgerDetail(personId: string, largeCategoryCode: LargeCategoryCode): Promise<GetPeopleLedgerDetailResponse> {
  const res = await apiClient.GET('/v2/people-ledger/people/{personId}/detail', {
    params: {
      path: {
        personId
      },
      query: {
        largeCategoryCode
      }
    }
  });
  return getDataOrThrowApiError(res);
}
export async function savePeopleLedgerDetail(personId: string, largeCategoryCode: LargeCategoryCode, sections: PeopleLedgerSection[]): Promise<void> {
  const res = await apiClient.PUT('/v2/people-ledger/people/{personId}', {
    params: {
      path: {
        personId
      }
    },
    body: {
      largeCategoryCode,
      sections
    }
  });
  getDataOrThrowApiError(res);
}